export default __webpack_public_path__ + "static/media/handicap-moteur.ba2c8626.svg";